import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal";

const CoachRecordVideoModal = ({ videoRecord }) => {
  const { t } = useTranslation("coaching-portal");

  return (
    <Modal width="" className="coach-record-video">
      <div className="head">{t("coachRecordVideo.title")}</div>
      <div className="body coach-record-video-modal">
        <div
          dangerouslySetInnerHTML={
            videoRecord &&
            videoRecord.video_html && {
              __html: videoRecord.video_html.replace(/(&lt;([^>]+)>)/gi, ""),
            }
          }
        ></div>
      </div>
    </Modal>
  );
};

export default CoachRecordVideoModal;
